import {
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAIL,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  GET_PURCHASES_SUCCESS,
  GET_PURCHASES_FAIL,
  ADD_PURCHASE_SUCCESS,
  ADD_PURCHASE_FAIL,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_FAIL,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_FAIL,
  GET_ARRIVED_PURCHASES_SUCCESS,
  GET_ARRIVED_PURCHASES_FAIL,
  GET_ARRIVED_PRODUCTS_SUCCESS,
  GET_ARRIVED_PRODUCTS_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  products: [],
  productsToOrder: [],
  managers: [],
  purchases: [],
  arrived_purchases: [],
  loading: false,
}

const purchases = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload[1],
        managers: action.payload[3],
      }
    case GET_PRODUCTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        products: [...state.products, action.payload],
        success: { data: "success" },
      }
    case ADD_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      }
    case UPDATE_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.filter(
          service => service.cNo.toString() !== action.payload._id.toString()
        ),
      }
    case DELETE_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      } 
    case GET_PURCHASES_SUCCESS:
      return {
        ...state,
        purchases: action.payload[0],
        products: action.payload[1],
        productsToOrder: action.payload[2],
        managers: action.payload[3],
      }
    case GET_PURCHASES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_PURCHASE_SUCCESS:
      return {
        ...state,
        purchases: [...state.purchases, action.payload[0]],
        productsToOrder: action.payload[1],
        success: { data: "success" },
      }
    case ADD_PURCHASE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_PURCHASE_SUCCESS:
      return {
        ...state,
        purchases: state.purchases.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      }
    case UPDATE_PURCHASE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_PURCHASE_SUCCESS:
      return {
        ...state,
        purchases: state.purchases.filter(
          service => service._id.toString() !== action.payload[0]._id.toString()
        ),
        productsToOrder: action.payload[1]
      }
    case DELETE_PURCHASE_FAIL:
      return {
        ...state,
        error: action.payload,
      } 
    case GET_ARRIVED_PURCHASES_SUCCESS:
      return {
        ...state,
        arrived_purchases: action.payload,
      }
    case GET_ARRIVED_PURCHASES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ARRIVED_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload,
      }
    case GET_ARRIVED_PRODUCTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default purchases
